import { observable, action } from "mobx";

class SponsorStore {
  @observable prevPath = '';
  @observable fromSponsor = false;
  @observable fromSponsorId = '';
  @observable sponsorId = '';


  @action setSponsors = (pathRoot) => {
    switch (pathRoot) {
      case 'iacp':
      case 'aci':
      this.sponsorId = pathRoot;
      this.fromSponsor = true;
      this.fromSponsorId = pathRoot;
      break
    default:
      this.sponsorId = '';
      break
    }
  }

  @action setPrevPath = (location) => {
    this.prevPath = location;
  }

  @action redirectFromSponsor = () => {
    const urlRoot = this.prevPath.split(/\//);
    if (urlRoot[1] === 'iacp' || urlRoot === 'aci') {
      this.fromSponsor = true;
      this.fromSponsorId = urlRoot[1]
    }
  }

  @action clearFromSponsor = () => {
    this.fromSponsor = false;
    this.fromSponsorId = '';
  }

}

export default new SponsorStore();




// WEBPACK FOOTER //
// ./src/stores/SponsorStore.js